import {useDispatch, useSelector} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import {codeConfirmation, setShowLoader} from '../../stores/customer-settings'
import {PageTitle, PageSubTitle, ResponsivePageTitle} from '../../components/core/title'
import Footer from '../../components/layouts/footer'
import {Formik} from 'formik'
import {codeSchema} from '../../utils/validation'
import Input from '../../components/core/input'
import {SimpleBlueButton} from '../../components/core/button'
import ButtonLoader from '../../components/core/button/ButtonLoader'
import classNames from 'classnames'
import {trimStringValues} from '../../utils/text'
import {useNamespaceTranslations} from '../../utils/hooks/useNamespacesTranslations'

const ConfirmCode = () => {
    const text = useNamespaceTranslations('confirm-code')
    const showLoader = useSelector(state => state.customer_settings.showLoader)
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const initialFormValues = {
        code: ''
    }
    const confirmCode = (values, {setFieldError, resetForm}) => {
        dispatch(codeConfirmation(trimStringValues(values), setFieldError, resetForm, navigate))
        dispatch(setShowLoader(true))
    }
    return (
        <main className={classNames('main settings', {
            dark: isDarkMode
        })}>
            <div>
                <ResponsivePageTitle/>
                <div className="content-title">
                    <div className="left-side">
                        <div>
                            <PageSubTitle>
                                <p className={classNames('section', {
                                    dark: isDarkMode
                                })}>{text.section}</p>
                            </PageSubTitle>
                            <PageTitle>
                                <h1  className={classNames('page-title', {
                                    dark: isDarkMode
                                })}>{text.title}</h1>
                            </PageTitle>
                        </div>
                    </div>
                </div>
                <div className="content-body">
                    <Formik
                        initialValues={initialFormValues}
                        onSubmit={confirmCode}
                        validationSchema={codeSchema}
                        validateOnBlur={false}
                        validateOnChange={false}>
                        {({values, errors, handleChange, handleSubmit}) => (
                            <form onSubmit={handleSubmit} className="form-elements">
                                <Input
                                    value={values.code}
                                    placeholder={text.confirmation_code}
                                    infoText={text.confirmation_code_info}
                                    name="code"
                                    onChange={handleChange}
                                    error={errors.code}
                                />
                                <SimpleBlueButton disabled={showLoader} type='submit'>
                                    {showLoader && <ButtonLoader />}
                                    {text.confirm}
                                </SimpleBlueButton>
                            </form>
                        )}
                    </Formik>
                </div>
            </div>
            <Footer/>
        </main>
    )
}
export default ConfirmCode
